import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementConfigurationsTypes } from '@api/manageNetworkElementConfigurations';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENT_CONFIGURATION_TYPES } from '@constants/queryKeys';

interface IUseQueryNetworkElementConfigurationTypesReturned {
	typesOptions: TSelectOption[];
	isLoadingTypesOptions: boolean;
}

const useQueryNetworkElementConfigurationTypes = (): IUseQueryNetworkElementConfigurationTypesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENT_CONFIGURATION_TYPES],
		queryFn: getNetworkElementConfigurationsTypes,
		select: nameTitleToOptionFormatted,
		...refetchOptions,
	});

	return {
		typesOptions: data || [],
		isLoadingTypesOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementConfigurationTypes;
